import React, { useEffect, useState } from "react";
import ReactEcharts from "echarts-for-react";
import { mockTooltipData } from "@components/Tooltip/tooltip.const";
import { Graph } from "../chart.types";
import { SunkeyChart } from "../chart.class";
import { Tooltip, TooltipGrapgicsData } from "@components/Tooltip/tooltip";
import { TooltipData } from "@components/TreeChart/chart.types";
import { CustomerJourneyTooltip } from "@components/CustomerJourneyMap/tooltip";

interface HorizontalChartProps {
  data: Graph;
  isAdType?: boolean;
  style?: React.CSSProperties;
  options?: any;
  seriesOptions?: any;
  tooltip?: string;
  onNodeClick?: (name: string) => void;
}

const getTooltipCustomer = () => ({
  roi: {
    value: "180%",
    increase: "4.7%",
    increaseIcon: "trendUp" as const,
  },
  sales: {
    value: "$120,000",
    increase: "3.2%",
    increaseIcon: "trendUp" as const,
  },
  spend: {
    value: "$42,857",
    increase: "0.2%",
    increaseIcon: "trendUp" as const,
  },
  userCount: {
    value: "50,000",
    increase: "0.8%",
    increaseIcon: "trendDown" as const,
  },
  dropOffUsers: {
    value: "22,000",
    increase: "5.2%",
    increaseIcon: "trendDown" as const,
  },
});

export const HorizontalChart: React.FC<HorizontalChartProps> = ({
  data,
  isAdType,
  style,
  options,
  seriesOptions,
  tooltip,
  onNodeClick,
}) => {
  const sunkeyChartInstance = new SunkeyChart();
  const [chartData, setChartData] = useState<Graph>(
    sunkeyChartInstance.formatData(data),
  );
  const [tooltipData, setTooltipData] = useState<TooltipData | null>(null);
  const [tooltipPositionY, setTooltipPositionY] = useState<number | null>(null);
  const [tooltipPositionX, setTooltipPositionX] = useState<number | null>(null);
  const [tooltipWithButton, setTooltipWithButton] = useState(false);
  const [tooltipWithImg, setTooltipWithImg] = useState(false);
  const [tooltipGraph, setTooltipGraph] = useState<TooltipGrapgicsData>();

  useEffect(() => {
    setChartData(sunkeyChartInstance.formatData(data));
  }, [data]);

  const clearStyles = () => {
    setTooltipData(null);
    setTooltipPositionY(null);
    setChartData(sunkeyChartInstance.clearOpacity(chartData));
    onNodeClick?.(null);
  };

  const onChartClick = (params: any) => {
    setTooltipWithButton(false);
    setTooltipWithImg(false);
    setTooltipGraph(undefined);
    onNodeClick?.(null);
    const tooltipName = params.name.replace(">", "--");

    const tooltipChartData =
      tooltip === "customer" ? getTooltipCustomer() : mockTooltipData;

    console.log({
      name: tooltipName,
      ...tooltipChartData,
    });

    setTooltipData({
      name: tooltipName,
      ...tooltipChartData,
    });
    setTooltipPositionY(params.event.offsetY - 250);
    setTooltipPositionX(params.event.offsetX);

    if (tooltipName.includes("--")) {
      setTooltipWithButton(true);
    }

    if (tooltipName.startsWith("Nyl") && isAdType) {
      setTooltipWithImg(true);
    }

    const { data, tooltipData } = sunkeyChartInstance.highlightNode(
      tooltipName,
      chartData,
    );

    setChartData(data);
    onNodeClick?.(tooltipName);

    if (tooltipData) {
      setTooltipGraph(tooltipData);
    }
  };

  console.log("chartData", tooltip);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
        ...style,
      }}
    >
      <ReactEcharts
        option={sunkeyChartInstance.getOption(
          chartData,
          options,
          seriesOptions,
        )}
        style={{ height: "720px", width: "1388px" }}
        onEvents={{ click: onChartClick }}
      />
      {tooltipData && tooltipPositionY !== null && (
        <>
          {tooltip === "customer" ? (
            <CustomerJourneyTooltip
              data={tooltipData}
              clearStyles={clearStyles}
              position={tooltipPositionY}
              positionX={tooltipPositionX}
            />
          ) : (
            <Tooltip
              data={tooltipData}
              clearStyles={clearStyles}
              position={tooltipPositionY}
              withImg={tooltipWithImg}
              withButton={tooltipWithButton}
              graphics={tooltipGraph}
            />
          )}
        </>
      )}
    </div>
  );
};
